import { render, staticRenderFns } from "./SocialMediaMarketing.vue?vue&type=template&id=1a24c227&scoped=true&"
import script from "./SocialMediaMarketing.vue?vue&type=script&lang=js&"
export * from "./SocialMediaMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a24c227",
  null
  
)

export default component.exports